// extracted by mini-css-extract-plugin
export default {"form-input":"form-input--NlQLK","formInput":"form-input--NlQLK"};